import React, { useEffect, useLayoutEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { CheckBoxData } from '../utils/UserDataCheckBox'
import { searchSpace } from '../services/ApiServices';
import { useDispatch } from 'react-redux';
import { setSpaceList } from '../store/slices/APIResponseSlice';
import { useHooks } from '../utils/getHooks';
import toast from 'react-hot-toast';
import countryList from '../assets/json/countries_states_cities.json';
import Select from "react-select";
import Autocomplete from "react-google-autocomplete";
export default function SideFilter({ show, setShow, setLoading }: { show: any, setShow: any, setLoading: any }) {
    console.log("countryList", countryList);

    const dispatch = useDispatch()
    const hooks = useHooks()
    console.log("hook", hooks.getSpaceList);
    const search = hooks.getSearchValue
    console.log("search", search);

    let [open, setOpen] = useState<boolean>(false)
    let [open2, setOpen2] = useState<boolean>(false)
    let [open3, setOpen3] = useState<boolean>(false)
    let [open4, setOpen4] = useState<boolean>(false)
    let [searchValue, setSearchValue] = useState<any>("")
    let [country, setCountry] = useState<string>("");
    let [selectPropertyType, setSelectPropertyType] = useState<any[]>([])
    let [isLeaseStatus, setIsLeaseStatus] = useState<string>("");
    let [searchCountry, setSearchCountry] = useState<string>("");
    let [countryLs, setCountryList] = useState<any[]>([])
    console.log("searchCountry", searchCountry);
    useEffect(() => {
        var countryData: any = [];
        countryList?.map((item: any) => {
            countryData.push({ label: item?.name, value: item?.name });
        });
        console.log("countryData", countryData);
        setCountryList(countryData);
    }, []);

    const [items, setItems] = useState([
        { label: 'North America', value: 'North America' },
        { label: 'South America', value: 'South America' },
        { label: 'Asia', value: 'Asia' },
        { label: 'Europe', value: 'Europe' },
        { label: 'Africa', value: 'Africa' },
        { label: 'Australia/New Zealand', value: 'Australia/New Zealand' },
    ]);

    useEffect(() => {
        setSelectPropertyType(search?.propertyType)
        setIsLeaseStatus(search?.isLease)
        searchSpaceAPICall(search?.propertyType, search?.isLease);
    }, [hooks.getSearchValue])

    const searchSpaceAPICall = (propertyType: any, isLease: any) => {
        // e.preventDefault()
        setLoading(true);
        const data = new FormData();
        if (propertyType.length > 0) {
            propertyType.forEach((item: any) => {
                data.append('property_type[]', item?.value);
            });
        }
        if (isLease === "1" || isLease === "0") {
            data.append('is_lease', isLease);
        }
        if (searchValue) {
            data.append('address', searchValue?.label);
        }
        if (searchCountry && searchCountry !== "all") {
            data.append('country', searchCountry === "all" ? "" : searchCountry);
        }
        if (country) {
            data.append('continent', country);
        }
        // data.append('is_lease', isLease);
        // data.append('address', searchValue?.label);

        searchSpace(data).then((res) => {
            console.log("get search space response", res);

            if (res?.status === "success") {
                dispatch(setSpaceList(res.data))
                setLoading(false)
            } else if (res?.status === "error") {
                dispatch(setSpaceList(res.data))
                setLoading(false)
            } else {
                console.log("search space error", res);
                setLoading(false)
            }
        })
    }

    const handlePropertyType = (item: any) => {
        if (selectPropertyType.includes(item)) {
            setSelectPropertyType(selectPropertyType.filter((property) => property !== item))
        } else {
            setSelectPropertyType([...selectPropertyType, item])
        }
    }

    const checkValidations = (e: any) => {
        e.preventDefault();
        if (!country) {
            toast.error("Please select a Continent");
            return;
        }
        if (selectPropertyType.length === 0) {
            toast.error("Please select at least one property type");
            return;
        }

        searchSpaceAPICall(selectPropertyType, isLeaseStatus);
    }
    return (
        <div className={`simple-sidebar sm-sidebar ${show ? 'd-block' : ''}`} id="filter_search" style={{ left: '0' }}>

            <div className="search-sidebar_header">
                <h4 className="ssh_heading">Close Filter</h4>
                <button className="w3-bar-item w3-button w3-large" onClick={() => setShow}><i className="fa-regular fa-circle-xmark fs-5 text-muted-2"></i></button>
            </div>

            <div className="sidebar-widgets">
                <div className="search-inner p-0">
                    <div className="filter-search-box">
                        <div className="form-group">
                            <div className="position-relative">
                                {/* <GooglePlacesAutocomplete
                                    apiKey="AIzaSyApsnfh0LcjwuVtDEEYVrzqCSw075qYEvg"
                                    selectProps={{
                                        value: searchValue,
                                        onChange: setSearchValue,
                                        isClearable: true,
                                        components: { DropdownIndicator: () => null, IndicatorSeparator: () => null }, // Hides dropdown icon
                                        hideSelectedOptions: true,
                                        className: "form-control border-0",
                                        placeholder: "Address Search...",
                                        filterOption: (option) => option.label.split(",").length >= 2,
                                    }}
                                /> */}

                                <Autocomplete
                                    apiKey="AIzaSyApsnfh0LcjwuVtDEEYVrzqCSw075qYEvg"
                                    onPlaceSelected={(place) => setSearchValue(place)}
                                    className="form-control border-0 px-5"
                                    options={{
                                        types: ["geocode"]
                                    }}
                                />
                                {/* <input type="text" className="form-control rounded-3 ps-5" placeholder="Search by space name…" /> */}
                                <div className="position-absolute top-50 start-0 translate-middle-y ms-2">
                                    <span className="svg-icon text-primary svg-icon-2hx">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1" transform="rotate(45 17.0365 15.1223)" fill="currentColor" />
                                            <path d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z" fill="currentColor" />
                                        </svg>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* 
                    <div className="position-relative d-flex flex-xl-row flex-column align-items-center">
                        <div className="verifyd-prt-block flex-fill full-width my-1 me-1">
                            <div className="d-flex align-items-center justify-content-center justify-content-between border rounded-3 px-2 py-3">
                                <div className="eliok-cliops d-flex align-items-center">
                                    <span className="svg-icon text-success svg-icon-2hx">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path opacity="0.3" d="M20.5543 4.37824L12.1798 2.02473C12.0626 1.99176 11.9376 1.99176 11.8203 2.02473L3.44572 4.37824C3.18118 4.45258 3 4.6807 3 4.93945V13.569C3 14.6914 3.48509 15.8404 4.4417 16.984C5.17231 17.8575 6.18314 18.7345 7.446 19.5909C9.56752 21.0295 11.6566 21.912 11.7445 21.9488C11.8258 21.9829 11.9129 22 12.0001 22C12.0872 22 12.1744 21.983 12.2557 21.9488C12.3435 21.912 14.4326 21.0295 16.5541 19.5909C17.8169 18.7345 18.8277 17.8575 19.5584 16.984C20.515 15.8404 21 14.6914 21 13.569V4.93945C21 4.6807 20.8189 4.45258 20.5543 4.37824Z" fill="currentColor" />
                                            <path d="M10.5606 11.3042L9.57283 10.3018C9.28174 10.0065 8.80522 10.0065 8.51412 10.3018C8.22897 10.5912 8.22897 11.0559 8.51412 11.3452L10.4182 13.2773C10.8099 13.6747 11.451 13.6747 11.8427 13.2773L15.4859 9.58051C15.771 9.29117 15.771 8.82648 15.4859 8.53714C15.1948 8.24176 14.7183 8.24176 14.4272 8.53714L11.7002 11.3042C11.3869 11.6221 10.874 11.6221 10.5606 11.3042Z" fill="currentColor" />
                                        </svg>
                                    </span><span className="text-muted-2 fw-medium ms-1">Verified</span>
                                </div>
                                <div className="form-check form-switch">
                                    <input className="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckChecked" checked />
                                    <label className="form-check-label" htmlFor="flexSwitchCheckChecked"></label>
                                </div>
                            </div>
                        </div>

                        <div className="super-agt-block flex-fill full-width my-1 ms-1">
                            <div className="d-flex align-items-center justify-content-center justify-content-between border rounded-3 px-2 py-3">
                                <div className="eliok-cliops d-flex align-items-center">
                                    <span className="svg-icon text-warning svg-icon-2hx">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24">
                                            <path d="M10.0813 3.7242C10.8849 2.16438 13.1151 2.16438 13.9187 3.7242V3.7242C14.4016 4.66147 15.4909 5.1127 16.4951 4.79139V4.79139C18.1663 4.25668 19.7433 5.83365 19.2086 7.50485V7.50485C18.8873 8.50905 19.3385 9.59842 20.2758 10.0813V10.0813C21.8356 10.8849 21.8356 13.1151 20.2758 13.9187V13.9187C19.3385 14.4016 18.8873 15.491 19.2086 16.4951V16.4951C19.7433 18.1663 18.1663 19.7433 16.4951 19.2086V19.2086C15.491 18.8873 14.4016 19.3385 13.9187 20.2758V20.2758C13.1151 21.8356 10.8849 21.8356 10.0813 20.2758V20.2758C9.59842 19.3385 8.50905 18.8873 7.50485 19.2086V19.2086C5.83365 19.7433 4.25668 18.1663 4.79139 16.4951V16.4951C5.1127 15.491 4.66147 14.4016 3.7242 13.9187V13.9187C2.16438 13.1151 2.16438 10.8849 3.7242 10.0813V10.0813C4.66147 9.59842 5.1127 8.50905 4.79139 7.50485V7.50485C4.25668 5.83365 5.83365 4.25668 7.50485 4.79139V4.79139C8.50905 5.1127 9.59842 4.66147 10.0813 3.7242V3.7242Z" fill="currentColor" />
                                            <path d="M14.8563 9.1903C15.0606 8.94984 15.3771 8.9385 15.6175 9.14289C15.858 9.34728 15.8229 9.66433 15.6185 9.9048L11.863 14.6558C11.6554 14.9001 11.2876 14.9258 11.048 14.7128L8.47656 12.4271C8.24068 12.2174 8.21944 11.8563 8.42911 11.6204C8.63877 11.3845 8.99996 11.3633 9.23583 11.5729L11.3706 13.4705L14.8563 9.1903Z" fill="white" />
                                        </svg>
                                    </span><span className="text-muted-2 fw-medium ms-1">SuperAgent</span>
                                </div>
                                <div className="form-check form-switch">
                                    <input className="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckChecked" checked />
                                    <label className="form-check-label" htmlFor="flexSwitchCheckChecked"></label>
                                </div>
                            </div>

                        </div>
                    </div> */}

                    <div className="filter_wraps">
                        <div className="single_search_boxed">
                            <div className="widget-boxed-header">
                                <h4>
                                    <Link to="#" onClick={() => setOpen(!open)} className={open ? '' : 'collapsed'}>Continent<span className="selected"></span></Link>
                                </h4>
                            </div>
                            <div className={`widget-boxed-body collapse ${open ? 'show' : ''}`} id="where">
                                <div className="side-list no-border">
                                    <div className="single_filter_card">
                                        <div className="card-body pt-0">
                                            <div className="inner_widget_link">
                                                <ul className="no-ul-list filter-list">
                                                    {items.map((item, index) => {
                                                        return (
                                                            <li className="form-check" key={index}>
                                                                <input
                                                                    id={item.value}
                                                                    className="form-check-input"
                                                                    name="where"
                                                                    type="radio"
                                                                    onChange={(e) => {
                                                                        console.log("item=======>", country);

                                                                        if (item?.value === country) {
                                                                            setCountry("")
                                                                        } else {
                                                                            setCountry(item?.value)
                                                                        }
                                                                    }}
                                                                />
                                                                <label htmlFor={item.value} className="form-check-label">{item?.label}</label>
                                                            </li>
                                                        )
                                                    })}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="single_search_boxed">
                            <div className="widget-boxed-header">
                                <h4>
                                    <Link to="#" onClick={() => setOpen4(!open4)} className={open4 ? '' : 'collapsed'}>Country</Link>
                                </h4>

                            </div>
                            <div className={`widget-boxed-body collapse ${open4 ? 'show' : ''}`}>

                                <li className="form-check">
                                    <input
                                        id='All'
                                        className="form-check-input"
                                        type="checkbox"
                                        onChange={(e) => setSearchCountry(e.target.checked ? "all" : "")}
                                        name={"All"}
                                        checked={searchCountry ? searchCountry === "all" : false}
                                    />
                                    <label htmlFor={"All"} className="form-check-label">{"All"}</label>
                                </li>
                                {searchCountry !== "all" && <Select
                                    options={countryLs ? countryLs : []}
                                    className="form-control mt-2"
                                    placeholder="Select Country"
                                    onChange={(e: any) => setSearchCountry(e.value)}
                                    value={countryLs.find((item: any) => item.value === searchCountry) || null}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 1000 }),
                                    }}
                                />}
                            </div>
                        </div>
                        <div className="single_search_boxed">
                            <div className="widget-boxed-header">
                                <h4>
                                    <Link to="#" onClick={() => setOpen2(!open2)} className={open2 ? '' : 'collapsed'}>Property Types</Link>
                                </h4>

                            </div>
                            <div className={`widget-boxed-body collapse ${open2 ? 'show' : ''}`}>
                                <div className="side-list no-border">

                                    <div className="single_filter_card">
                                        <div className="card-body pt-0">
                                            <div className="inner_widget_link">
                                                <ul className="no-ul-list filter-list">
                                                    {CheckBoxData.map((item, index) => {
                                                        console.log("item",);

                                                        return (
                                                            <li className="form-check" key={index}>
                                                                <input
                                                                    id={item.label}
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    onChange={(e) => handlePropertyType(item)}
                                                                    name={item?.value}
                                                                    checked={selectPropertyType.includes(item)}
                                                                />
                                                                <label htmlFor={item.label} className="form-check-label">{item.label}</label>
                                                            </li>
                                                        )
                                                    })}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="single_search_boxed">
                            <div className="widget-boxed-header">
                                <h4>
                                    <Link to="#" onClick={() => setOpen3(!open3)} className={open3 ? '' : 'collapsed'}>Status</Link>
                                </h4>
                            </div>
                            <div className={`widget-boxed-body collapse ${open3 ? 'show' : ''}`}>
                                <div className="side-list no-border">

                                    <div className="single_filter_card">
                                        <div className="card-body pt-0">
                                            <div className="inner_widget_link">
                                                <ul className="no-ul-list filter-list">
                                                    <li className="form-check">
                                                        <input
                                                            id={"sale"}
                                                            className="form-check-input"
                                                            type="radio"
                                                            onChange={(e) => setIsLeaseStatus("0")}
                                                            name={"0"}
                                                            checked={isLeaseStatus === "0"}
                                                        />
                                                        <label htmlFor={"sale"} className="form-check-label">For Sale</label>
                                                    </li>
                                                    <li className="form-check">
                                                        <input
                                                            id={"lease"}
                                                            className="form-check-input"
                                                            type="radio"
                                                            onChange={(e) => setIsLeaseStatus("1")}
                                                            name={"1"}
                                                            checked={isLeaseStatus === "1"}
                                                        />
                                                        <label htmlFor={"lease"} className="form-check-label">For Lease</label>
                                                    </li>
                                                    <li className="form-check">
                                                        <input
                                                            id={"both"}
                                                            className="form-check-input"
                                                            type="radio"
                                                            onChange={(e) => setIsLeaseStatus("")}
                                                            name={""}
                                                            checked={isLeaseStatus === ""}
                                                        />
                                                        <label htmlFor={"both"} className="form-check-label">Both</label>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="form-group filter_button">
                        <button type="submit" className="btn btn btn-primary rounded full-width"
                            onClick={(e) => {
                                // e.preventDefault();
                                checkValidations(e);
                                // searchSpaceAPICall(selectPropertyType, isLeaseStatus)
                            }}>Search</button>
                    </div>
                </div>
            </div>
        </div>
    )
}
